import React from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './logo-edisec.png';
import Button from 'react-bootstrap/Button';



function BasicExample() {
  return (
    <Navbar bg="light" expand="lg">
      <Container>
        <Navbar.Brand href="#home"><img src={logo} width="150px" alt="logo" /> </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto">
            <Nav.Link  href="#sobre-nosotros">Sobre nosotros</Nav.Link>
            <Nav.Link  href="#obras-realizadas">Obras realizadas</Nav.Link>
            <Nav.Link href="#protecnus">Protecnus</Nav.Link>
            
            <Nav.Link href="#nuestros-clientes">Nuestros clientes</Nav.Link>
            <Nav.Link href="#contacto">Contacto</Nav.Link>
            <Button >Iniciar Sesión</Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default BasicExample;